<div class="filter-wrapper ml-1" *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.FILTER_BAR)">
  <div class="row justify-content-end">
    <!-- Zonal Manager -->
    <div class="col-auto" *ngIf="role_id == ROLE_CONSTANTS.HO">
      <ng-multiselect-dropdown [placeholder]="'Zonal Manager'" class="form-control head-multiselect"
        [settings]="zoneSettings" [data]="ZoneManagerList" [(ngModel)]="selectedZonalMgrs"
        (onSelect)="onZoneSelect($event)" (onDeSelect)="onZoneDeSelect($event)" (keydown)="$event.stopPropagation()">
      </ng-multiselect-dropdown>
    </div>

    <!-- Regional Manager -->
    <div class="col-auto" *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.FILTER_BAR_REGIONAL)">
      <ng-multiselect-dropdown [placeholder]="'Regional Manager'" class="form-control head-multiselect"
        [(ngModel)]="selectedRegionalMgrs" [settings]="regionSettings" [data]="RegionManagerList"
        (onSelect)="onRegionSelect($event)" (onDeSelect)="onregionDeSelect($event)" [disabled]="
          role_id === ROLE_CONSTANTS.HO && (!selectedZonalMgrs || selectedZonalMgrs.length === 0)
        " (click)="showErrorForRegion()" (keydown)="$event.stopPropagation()">
      </ng-multiselect-dropdown>
    </div>

    <!-- Area Manager -->
    <div class="col-auto" *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.FILTER_BAR)">
      <ng-multiselect-dropdown [placeholder]="'Area Manager'" class="form-control head-multiselect"
        [settings]="areaSettings" [data]="AreaManagerList" [(ngModel)]="selectedAreaMgrs"
        (onSelect)="onAreaSelect($event)" (onDeSelect)="onAreaDeSelect($event)" [disabled]="
          (role_id === ROLE_CONSTANTS.HO || role_id === ROLE_CONSTANTS.ZM) &&
          (!selectedRegionalMgrs || selectedRegionalMgrs.length === 0)
        " (click)="showErrorForArea()" (keydown)="$event.stopPropagation()">
      </ng-multiselect-dropdown>
    </div>

    <!-- Outlets -->
    <div class="col-auto"
      *ngIf="showOutlets && (roleService.hasRole(role_id, ROLE_GROUP_CONSTANTS.FILTER_BAR) || role_id == ROLE_CONSTANTS.AM || role_id == ROLE_CONSTANTS.DP)">
      <ng-multiselect-dropdown [placeholder]="'Select Outlets'" class="form-control head-multiselect"
        [settings]="outletSettings" [data]="OutletList" [(ngModel)]="selectedOutlets"
        (onSelect)="onOutletSelect($event)" (onDeSelect)="onOutletDeSelect($event)" (click)="showErrorForOutlets()"
        (keydown)="$event.stopPropagation()">
      </ng-multiselect-dropdown>
    </div>

    <!-- Apply Button -->
    <div class="col-auto">
      <button class="btn blue-btn" type="button" (click)="apply()">
        Apply
      </button>
    </div>

    <div class="rotate-icon-container p-0 ml-1 mr-1" (click)="clearFilters(false)">
      <span class="rotate-icon" title="Clear Filter"></span>
    </div>
  </div>
</div>